import { RECEIVABLES, PAYABLES } from '../constants/LedgerTypes';
import { isIntermodalShipmentType } from './shipment-types';
export const getUnprocessedItems = (shipment, ledgerType) => {
    return (shipment[ledgerType] || []).filter((adj) => !adj.processed);
};
export const getUnprocessedReceivables = (shipment) => {
    return getUnprocessedItems(shipment, RECEIVABLES);
};
export const getUnprocessedPayables = (shipment) => {
    return getUnprocessedItems(shipment, PAYABLES);
};
export const mapIsUnappliedAdjustment = (shipment) => (lineItem) => isIntermodalShipmentType(shipment) && !lineItem.equipment;
export const isApproveDisabled = (charge) => Boolean(charge === null || charge === void 0 ? void 0 : charge.approved) || Boolean(charge === null || charge === void 0 ? void 0 : charge.processed);
export const canShowEditAction = (charge, isFinance = false) => isFinance && !(charge === null || charge === void 0 ? void 0 : charge.processed) && !(charge === null || charge === void 0 ? void 0 : charge.accessorial_request_id);
export const canShowApproveAction = (charge) => ((charge === null || charge === void 0 ? void 0 : charge.type) === 'carrier_cost' || (charge === null || charge === void 0 ? void 0 : charge.category) === 'base_cost') &&
    !(charge === null || charge === void 0 ? void 0 : charge.parent_adjustment_id);
export const canShowDeleteAction = (charge, isFinance = false, isIntermodal = true) => isFinance &&
    !(charge === null || charge === void 0 ? void 0 : charge.processed) &&
    (isIntermodal ? !(charge === null || charge === void 0 ? void 0 : charge.accessorial_request_id) : true);
export function getOutstandingTotal(shipment, ledgerType) {
    return getUnprocessedItems(shipment, ledgerType).reduce((total, item) => {
        return total + (item.value || 0);
    }, 0);
}
